import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'next/components/ui';

const OPTIONS = [
  { value: 'page', label: 'Anytime the page matches' },
  { value: 'include', label: 'Always' },
];

export default function Taco({ rule, setWidgetFilter }) {
  // taco defaults to "page" mode when widgetFilter is missing
  const tacoOption = rule.widgetFilter || 'page';
  const tacoEnabled = ['page', 'include'].includes(tacoOption);

  const selected = OPTIONS.find(({ value }) => value === tacoOption);

  return (
    <div>
      <div className="option">
        <label className="radio">
          <input
            type="checkbox"
            onClick={() => {
              if (tacoEnabled) {
                setWidgetFilter(rule.id, 'exclude');
              } else {
                setWidgetFilter(rule.id, 'page');
              }
            }}
            checked={tacoEnabled}
          />
          Show this flow in Launchpad
        </label>
      </div>

      {tacoEnabled && (
        <div className="content">
          <Select
            value={selected}
            options={OPTIONS}
            onChange={({ value }) => {
              setWidgetFilter(rule.id, value);
            }}
          />
        </div>
      )}
    </div>
  );
}

Taco.propTypes = {
  rule: PropTypes.shape({
    id: PropTypes.string,
    widgetFilter: PropTypes.string,
  }),
  setWidgetFilter: PropTypes.func,
};
